// Helpers de seleção de usuários (ex.: campo "Responsável" de processo/relatório).

// Position 0 = Cliente, 1 = ClientStatus. Ambos são contas de cliente (ver utils/screens.ts).
export const CLIENT_POSITIONS = [0, 1];

export interface ResponsibleOption {
  id: string;
  name: string;
}

const isClient = (u: any) => CLIENT_POSITIONS.includes(u?.position ?? 0);

// Empresa "Geral" enxerga todas as empresas (mesma regra do backend em ProcessRepository).
const seesAllCompanies = (company?: string) =>
  !company || company.trim().toLowerCase() === "geral";

/**
 * Usuários elegíveis a "Responsável": exclui contas de cliente e mantém só os da
 * empresa do usuário logado (`auth.company`, nome da empresa). Empresa "Geral"
 * (ou empresa ausente, ex.: sessão antiga) vê usuários de todas as empresas.
 */
export const getResponsibleOptions = (
  users: any[],
  authCompany?: string,
): ResponsibleOption[] =>
  (Array.isArray(users) ? users : [])
    .filter((u) => !isClient(u))
    .filter((u) => seesAllCompanies(authCompany) || u?.company === authCompany)
    .map((u) => ({ id: u.id, name: (u.name ?? u.email ?? "").trim() }))
    .filter((u) => !!u.name)
    .sort((a, b) => a.name.localeCompare(b.name, "pt-BR"));
